/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {DiplomatObject} from './DiplomatObject';
import {DiplomatObjectType} from './DiplomatObjectType';

export const DiplomatFolder = DiplomatObject.shape({
   level: yup.number().integer(),
   comparisonText: yup.string(),
   immutable: yup.boolean(),
   addable: yup.boolean(),
   childObjectType: yup.string().oneOf(DiplomatObjectType.keys),
});
export type IDiplomatFolder = yup.InferType<typeof DiplomatFolder>;
